<template>
  <div class="slider">
    <swiper class="swiper" :options="swiperOption">
      <swiper-slide v-for="image in images" :key="image">
        <div class="slide-img" :style="`background: url(${image}) center / cover no-repeat`"></div>
      </swiper-slide>
      <swiper-slide v-for="video in videos" :key="video">
        <div class="slide-img">
          <b-embed
            type="iframe"
            :src="video"
            frameborder="0"
            allowfullscreen
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          ></b-embed>
        </div>
      </swiper-slide>

      <div class="swiper-pagination" slot="pagination"></div>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
  </div>
</template>
<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      swiperOption: {
        spaceBetween: 50,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      }
    };
  },
  props: {
    videos: Array,
    images: Array
  }
};
</script>
